import PropTypes from "prop-types";

// Small inline SVG icons for the viewer controls (no icon dependency).

export const CheckIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </svg>
);

export const DeleteIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

// Palette icon — filled ("Color On") or outlined ("Color Off").
const PALETTE_PATH =
  "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.16-.64-1.67-.08-.09-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 8 6.5 8 8 8.67 8 9.5 7.33 11 6.5 11zm3-4C8.67 7 8 6.33 8 5.5S8.67 4 9.5 4s1.5.67 1.5 1.5S10.33 7 9.5 7zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 4 14.5 4s1.5.67 1.5 1.5S15.33 7 14.5 7zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 8 17.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z";

export const PaletteIcon = ({
  size = 24,
  color = "currentColor",
  outlined,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={outlined ? "none" : color}
    stroke={outlined ? color : "none"}
    strokeWidth={outlined ? 1.4 : 0}
  >
    <path d={PALETTE_PATH} />
  </svg>
);

// Wireframe / "X-Ray" icon: a triangle mesh drawn as outlines.
export const WireframeIcon = ({ size = 24, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.6}
    strokeLinejoin="round"
    strokeLinecap="round"
  >
    <path d="M12 3 L21 18 L3 18 Z" />
    <path d="M12 3 L12 18" />
    <path d="M3 18 L12 11 L21 18" />
  </svg>
);

const iconProps = {
  size: PropTypes.number,
  color: PropTypes.string,
};
CheckIcon.propTypes = iconProps;
DeleteIcon.propTypes = iconProps;
PaletteIcon.propTypes = { ...iconProps, outlined: PropTypes.bool };
WireframeIcon.propTypes = iconProps;

// Ruler icon — the "Auto Measure" control.
export const RulerIcon = ({ size = 24, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.6}
    strokeLinejoin="round"
    strokeLinecap="round"
  >
    <path d="M3.5 14.5 L14.5 3.5 L20.5 9.5 L9.5 20.5 Z" />
    <path d="M7 11 L9 13" />
    <path d="M10 8 L12 10" />
    <path d="M13 5 L15 7" />
  </svg>
);

RulerIcon.propTypes = iconProps;
